<div class="flex flex-col flex-auto min-w-0">
    <div class="flex-auto p-6 border-t ">
        <div class="flex flex-col sm:flex-row flex-auto sm:items-center min-w-0 my-8 sm:my-12">
            <!-- Avatar and name -->
            <div class="flex flex-auto items-center min-w-0">

                <div class="flex flex-col min-w-0 ml-4">
                    <ng-container *transloco="let t">
                        <div
                            class="text-2xl md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate">
                            Liste Fichiers</div>
                    </ng-container>

                </div>
            </div>
            <!-- Actions -->
            <div class="flex items-center sm:mt-0 sm:ml-2 space-x-3">

                <button class="fuse-mat-button-rounded" mat-flat-button [color]="'primary'">
                    <input id="upload" type="file" hidden accept=".xml" multiple (change)="getFiles($event)" />
                    <label for="upload">
                        <mat-icon class="icon-size-5 mr-3" svgIcon="mat_solid:upload"></mat-icon>
                       
                    </label>
                  <label for="upload">Télécharger</label>  
                </button>
            </div>
        </div>
        <div class="w-full max-w-screen-xl mx-auto">
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full min-w-0">
                <!-- Summary -->
                <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">

                    <div class="flex flex-col items-center mt-2 cursor" (click)="getListTransaction()">
                        <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-blue-500">
                            <mat-spinner *ngIf="loader && !total && nb_not_executed!==0" [diameter]="25" ></mat-spinner>    {{total}}
                        </div>
                        <div class="text-lg font-medium text-blue-600 dark:text-blue-500">Nombre Total</div>

                    </div>
                </div>
                <!-- Overdue -->
                <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">

                    <div class="flex flex-col items-center mt-2 cursor" (click)="filterWithExecuted(false)">
                        <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-red-500">
                            <mat-spinner *ngIf="loader && !nb_not_executed && nb_not_executed!==0" [diameter]="25" ></mat-spinner> {{nb_not_executed}}
                        </div>
                        <div class="text-lg font-medium text-red-600 dark:text-red-500">Non traité(s)</div>

                    </div>
                </div>

                <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">

                    <div class="flex flex-col items-center mt-2 cursor" (click)="filterWithExecuted(true)">
                        <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-green-500">
                            <mat-spinner *ngIf="loader && !nb_executed && nb_executed!==0" [diameter]="25" ></mat-spinner> {{nb_executed}}</div>
                        <div class="text-lg font-medium text-green-600 dark:text-green-500">Traité(s)</div>

                    </div>
                </div>
            </div>
            <div class="grid grid-cols-1 xl:grid-cols-2 gap-8 w-full mt-5">
                <div class="xl:col-span-2 flex flex-col flex-auto bg-card shadow rounded-2xl ">
                    <div
                        class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b ng-tns-c239-238">
                        <div
                            class="text-lg font-medium tracking-tight leading-6 truncate  tracking-tight ng-tns-c239-238">
                        </div>
                        <div class="  flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4 ng-tns-c239-238">
                            <mat-form-field appearance="fill"
                                class=" mat-form-field fuse-mat-no-subscript fuse-mat-rounded inputSsearch ">
                                <input [(ngModel)]="inputValue" matInput (keyup)="applyFilter($event)" placeholder="Chercher ..." #input
                                    class="inputSearch">
                                <mat-icon svgIcon="heroicons_outline:search"></mat-icon>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="overflow-x-auto mx-6">
                        <table [dataSource]="listData" mat-table style="width: 100%;">
                            <ng-container matColumnDef="No">
                                <mat-header-cell class="d-flex justify-content-center align-items-center custemClass"
                                    *matHeaderCellDef>N°</mat-header-cell>
                                <mat-cell *matCellDef="let element ; let i = index;"
                                    class=" font-medium text-sm text-secondary whitespace-nowrap d-flex custemClass">{{i+1}}</mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="file">
                                <mat-header-cell *matHeaderCellDef
                                    class="d-flex justify-content-center align-items-center custemWidthMax">Nom
                                    fichier</mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class="font-medium text-sm text-secondary whitespace-nowrap custemWidthMax  d-flex justify-content-center cursor">
                                    <a class="file-link"
                                        (click)="getFile(element.file_name , 'f')">{{element.file_name}}</a></mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="date">
                                <mat-header-cell *matHeaderCellDef
                                    class="d-flex justify-content-center align-items-center">Date
                                    d'execution</mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class=" font-medium text-sm text-secondary whitespace-nowrap d-flex justify-content-center align-items-center">{{element.createdAt}}</mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="excutedBy">
                                <mat-header-cell *matHeaderCellDef
                                    class="d-flex justify-content-center align-items-center">Executé
                                    par</mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class=" font-medium text-sm text-secondary whitespace-nowrap d-flex justify-content-center align-items-center">{{element.executed_by.name}}</mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="mail">
                                <mat-header-cell *matHeaderCellDef
                                    class="d-flex justify-content-center align-items-center">Email</mat-header-cell>
                                <mat-cell *matCellDef="let element"
                                    class=" font-medium text-sm text-secondary whitespace-nowrap d-flex justify-content-center align-items-center">{{element.executed_by.email}}</mat-cell>
                            </ng-container>


                            <ng-container matColumnDef="rapport">
                                <mat-header-cell *matHeaderCellDef class="custemWidthMin"> Rapport</mat-header-cell>
                                <mat-cell class="d-flex justify-content-center align-items-center custemWidthMin"
                                    *matCellDef="let element">
                                    <mat-icon svgIcon="mat_solid:file_download" class="cursor" matTooltip="Voir Rapport"
                                        (click)="getFile(element.file_name , 'r')"
                                        *ngIf="element.details.rapport_name"></mat-icon>
                                    <span *ngIf="!element.details.rapport_name">-</span>
                                    <!-- <span (click)="getFile(element.file_name , 'r')">{{element.details.rapport_name}}</span>  -->
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="executed">
                                <mat-header-cell *matHeaderCellDef
                                    class="d-flex justify-content-center align-items-center custemWidthMin">Statut</mat-header-cell>
                                <mat-cell *matCellDef="let element "
                                    class=" font-medium text-sm text-secondary whitespace-nowrap d-flex justify-content-center align-items-center custemWidthMin">
                                    <span *ngIf="element.executed">
                                        <img src="assets/icons/check-circle.svg">
                                    </span>
                                    <span *ngIf="!element.executed">
                                        <img src="assets/icons/times-icon.svg">
                                    </span>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

                        </table>
                        <div class=" text-center custemHeight   d-flex justify-content-center " *ngIf="loader === true">
                            <mat-spinner [diameter]="25" ></mat-spinner>
                        </div>
                        <div class="custemHeight" *ngIf=" listTransation.length == 0 && loader === false">
                            <p class=" row w-full py-2 font-medium text-m text-secondary d-flex justify-content-center ">
                                Pas des fichiers
                            </p>
                        </div>

                        <nav aria-label="Page navigation example" *ngIf="listTransation.length>0 && loader === false">
                            <div class="text-center">
                                <ul class="pagination">
                                    <li (click)="first()" [ngClass]="{'disabled-first-pagination':isFirst()}"
                                        class="page-item">
                                        <a class=" font-medium text-sm text-secondary page-link "><span
                                                aria-hidden="true">&laquo;</span></a>
                                    </li>
                                    <li *ngIf="!isFirst()" (click)="prev()">
                                        <a class=" ml-0 font-medium text-sm text-secondary page-link">‹</a>
                                    </li>
                                    <ng-container *ngFor="let item of [].constructor(3); let i = index">
                                        <li *ngIf="i+pageNumber-3>0" class="page-item">
                                            <a class=" font-medium text-sm text-secondary page-link"
                                                (click)="changepage(i+pageNumber-3)">{{i + pageNumber - 3}}</a>
                                        </li>
                                    </ng-container>
                                    <ng-container *ngFor="let item of [].constructor(3); let i = index">
                                        <li *ngIf="i+pageNumber<totalPages" class="page-item">
                                            <a (click)="changepage(i+pageNumber)"
                                                [ngClass]="{'active-page':pageNumber===(i+pageNumber)}"
                                                class="page-link text-secondary  font-medium text-sm">
                                                {{i + pageNumber}}
                                            </a>
                                        </li>
                                    </ng-container>
                                    <li *ngIf="totalPages>3"> <a
                                            class=" ml-0 font-medium text-sm text-secondary page-link ">...</a> </li>
                                    <li class=" mr-2 page-item text-center">
                                        <a *ngIf="totalPages>0" (click)="changepage(totalPages)"
                                            [ngClass]="{'active-page':pageNumber===totalPages}"
                                            class=" page-link  font-medium text-sm text-secondary ">{{totalPages}}</a>
                                        <a *ngIf="totalPages===0" (click)="changepage(totalPages)"
                                            [ngClass]="{'active-page':pageNumber===totalPages+1}"
                                            class=" font-medium text-sm text-secondary page-link">{{totalPages+1}}</a>
                                    </li>
                                    <li *ngIf="!isLast() && totalPages>0" (click)="next()">
                                        <a class=" ml-0 font-medium text-sm text-secondary page-link">›</a>
                                    </li>
                                    <li (click)="last()" *ngIf="totalPages>0"
                                        [ngClass]="{'disabled-first-pagination':isLast()}" class=" ml-1 page-item">
                                        <a class="page-link-symbol  font-medium text-sm text-secondary page-link">
                                            <span aria-hidden="true">&raquo;</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>